import { useParams } from "react-router-dom";
import { defaultLocale, isSupportedLocale, keys } from "@/lib/i18n/portal";
import { Link } from "react-router-dom";
import { useTranslations } from "@/lib/i18n/intl";
import { PageLayout } from "@/shared/layout/PageLayout";

function getResolvedLocale(value: string | undefined) {
  return value && isSupportedLocale(value) ? value : defaultLocale;
}

export function ForgotPasswordPage() {
  const { locale: routeLocale } = useParams();
  const locale = getResolvedLocale(routeLocale);
  const t = useTranslations();

  return (
    <PageLayout
      title={t(keys.auth.forgotPasswordTitle)}
      subtitle={t(keys.auth.forgotPasswordSubtitle)}
      logoAlt={t(keys.common.appName)}
      variant="centered"
      softBackdrop
      centeredSurface="none"
    >
      <div className="mx-auto flex w-full max-w-[640px] flex-col gap-4">
        <p className="rounded-xl border border-[color:var(--border-light)] bg-[color:var(--surface)] px-4 py-3 text-sm text-[color:var(--text-secondary)]">
          {t(keys.auth.forgotPasswordBody)}
        </p>
        <Link
          to={`/${locale}/login`}
          className="inline-flex h-11 items-center justify-center rounded-lg bg-[color:var(--primary-500)] px-4 text-sm font-semibold text-white transition hover:bg-[color:var(--primary-600)]"
        >
          {t(keys.auth.forgotPasswordBack)}
        </Link>
      </div>
    </PageLayout>
  );
}
